import { render, staticRenderFns } from "./ProfileRequest.vue?vue&type=template&id=b472bba8"
import script from "./ProfileRequest.vue?vue&type=script&lang=js"
export * from "./ProfileRequest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports